module.exports = __webpack_public_path__ + "img/flecha-anterior.01b2cb6b.svg";